import React from 'react'
import messages from './messages'
import { useIntl } from 'react-intl'
import { MenuButton } from '@arnsbogroup/react-voicearchive'
import { Menu } from '@headlessui/react'
import NiceModal from '@ebay/nice-modal-react'
import AddTaskSupplierDialog from '../AddTaskSupplierDialog'

const ChangeSupplier = ({ readOnly, task, order, files, refetch, version }) => {
  const { formatMessage } = useIntl()

  const onClick = () => {
    NiceModal.show(AddTaskSupplierDialog, { order, task, files, reAssign: true, version })
      .then(refetch)
      .catch((error) => {
        console.error(error)
      })
  }

  return (
    <Menu.Item key='changeSupplier' disabled={readOnly}>
      {(props) => (
        <MenuButton disabled={readOnly} {...props} onClick={onClick}>
          { formatMessage(messages.changeSupplier) }
        </MenuButton>
      )}
    </Menu.Item>
  )
}

export default ChangeSupplier
